/*
  Confirms an email-address change from the link sent to the new address.
  Route: /verify-email/:token  ->  POST /accounts/verify-email-change/
*/
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Col, Spin } from "antd";

import MainScreen from "../ForgotPassword";
import APP_URL from "constants/ApplicationUrls";
import { API_URLS } from "constants/ApiUrl";
import { postAction } from "store/actions/CRUDAction";
import LOCALIZATION from "services/LocalizationService";

const VerifyEmail = () => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const sent = useRef(false);
  const [state, setState] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    if (sent.current) return; // confirm once, even under StrictMode double effects
    sent.current = true;
    dispatch(postAction(API_URLS.VERIFY_EMAIL_CHANGE, { token }, {}, "VERIFY_EMAIL_CHANGE")).then(
      () => setState({ loading: false, ok: true, message: "Your email address has been updated. Please log in with your new email." }),
      (e) => setState({
        loading: false,
        ok: false,
        message: e?.response?.data?.Failed || "This verification link is invalid or has expired.",
      })
    );
  }, [dispatch, token]);

  return (
    <MainScreen>
      <Col span={24} className="link-wrapper mb-15">
        <h2>Confirm email address</h2>
        {state.loading ? <Spin /> : <p>{state.message}</p>}
        {!state.loading && (
          <Button type="auth" onClick={() => history.push(APP_URL.AUTH.LOGIN)}>
            {LOCALIZATION.BACK_TO_LOGIN}
          </Button>
        )}
      </Col>
    </MainScreen>
  );
};

export default VerifyEmail;
